import { Navigate } from "react-router-dom";
import { resolveTruckYardHomeRoute } from "../../../hooks/useTruckYardRole";

/**
 * Índice de `/truck-yard`: manda a la pantalla de entrada del rol. Admins y
 * supervisores caen en la lista de patios; el vigilante en Accesos, que es la
 * única sección que el menú le muestra.
 */
export default function TruckYardIndexRedirect() {
  const roleId = localStorage.getItem("userRoleId") || "";
  return <Navigate to={resolveTruckYardHomeRoute(roleId)} replace />;
}
